import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';

export default function LegacyTeregoReturn() {
    const {search, hash} = useLocation();
    return <Navigate replace to={`/comenzi/terego-return${search}${hash}`} />;
}
